var commitDate = '20210222';
window.gs = window.gs || {};

(function($){
	"use strict";
	
	var gsf_tq_placeholder;
	
	$('#gsf_tq')
	.focus(function(e){
		gsf_tq_placeholder = $(this).attr('placeholder');
		$(this).attr('placeholder', '');
	})
	.blur(function(e){
	    $(this).attr('placeholder', gsf_tq_placeholder);
	});
	
	$('#gsf_tq').on('keyup keydown', function(e){
		var ev = event || window.event;
		var keyCode = ev.which || ev.keyCode;
		
		if(ev.type == 'keydown') {
			switch(keyCode) {
			case 38: //위쪽 방향키
			case 40: //아래쪽 방향키
			case 191: //슬래시, 물음표
			case 222: //따옴표, 큰따옴표
				return false;
			}
		} else {
			switch(keyCode) {
			case 13: //엔터
				wineSearch();
				return false;
			}
		}
	});

	$('#wineSearchSubmit').click(function(e){
    	wineSearch();
    });
})(jQuery);

function wineSearch() {
	var $wineTq = $('#gsf_tq');
	var wineTqVal = $wineTq.val();
	var lseqVal = $('#searchLseq').val();
	
	if(!wineTqVal) {
		alert('검색어를 입력해 주세요.');
		$wineTq.val('').focus();
		return;
	}
	
	if(lseqVal){
		location.href = '/shop/wine/search.gs?tq='+ encodeURIComponent(wineTqVal) + '&lseq=' + lseqVal;		//lseq 있는 경우
	}else {
		location.href = '/shop/wine/search.gs?tq='+ encodeURIComponent(wineTqVal);		
	}
}

/*
 * 큐레이션 수동 탭 클릭 -> 탭별 상품목록 조회
 */
function wineTabClick(planSeq, tabId, tabIdx){
	
	var url = "/shop/wine/wineTabPrdList.gs?";
	
	var modIdx = Number(tabIdx)+1; // 모듈순서
	var lseq = "424341-" + modIdx; // lseq 세팅	
	LSeqUtil.clickLseqSend(lseq);	//효율코드 호출
	
	$.ajax({
		url : url,
		data : {
			"planSeq" : planSeq,
			"paramSectId" : tabId,
			"autoYn" : "N", 
			"tabIdx" : tabIdx
		},
		type : 'get',
		success : function(data) {
			//html세팅
			$('#wineTab_'+tabIdx).html(data);
			//페이지 스와이퍼 세팅
			$(function(){
				$('#swiper-'+tabIdx).gsSwiper({ autoplay:0, slideIS:true, controlClass:'pg-ctrl-box', resizeIS:true});
			});
		}
	});
	
}

/*
 * 큐레이션 자동 탭 클릭 -> 탭별 상품목록 조회
 */
function wineAutoTabClick(searchType, searchDtl, tabOrder ,tabIdx){
	
	var url = "/shop/wine/wineTabPrdList.gs?"; 
	
	var modIdx = Number(tabOrder)+1; // 모듈순서 (탭순서)
	var lseq = "";	
	if(searchType == "brix"){
		lseq = "424346-" + modIdx;
		LSeqUtil.clickLseqSend(lseq);	//효율코드 호출
	}else if(searchType == "price"){
		lseq = "424347-"+ modIdx;
		LSeqUtil.clickLseqSend(lseq);	//효율코드 호출
	}else if(searchType == "country"){
		lseq = "424348-"+ modIdx;
		LSeqUtil.clickLseqSend(lseq);	//효율코드 호출
	}
		
	$.ajax({
		url : url,
		data : {
			"searchType" : searchType,
			"searchDtl" : searchDtl,
			"autoYn" : "Y", 
			"tabIdx" : tabIdx
		},
		type : 'get',
		success : function(data) {
			//html세팅
			$('#wineAutoTab_'+tabIdx).html(data);
			//페이지 스와이퍼 세팅
			$(function(){
				$('#swiper-auto-'+tabIdx).gsSwiper({ autoplay:0, slideIS:true, controlClass:'pg-ctrl-box', resizeIS:true});
			});
		}
	});
	
}